export const snippetRef = 'snippet-ref';
